import React from "react";

interface StaticImageProps {
  src: string;
  alt: string;
  width?: number;
  height?: number;
  className?: string;
  imgClassName?: string;
  style?: React.CSSProperties;
  imgStyle?: React.CSSProperties;
  loading?: "eager" | "lazy";
  objectFit?: React.CSSProperties["objectFit"];
  objectPosition?: React.CSSProperties["objectPosition"];
  backgroundColor?: string;
  placeholder?: "blurred" | "dominantColor" | "none";
  formats?: string[];
  quality?: number;
  breakpoints?: number[];
  transformOptions?: any;
  as?: React.ElementType;
}

const StaticImage: React.FC<StaticImageProps> = ({
  src,
  alt,
  width,
  height,
  className = "",
  imgClassName = "",
  style = {},
  imgStyle = {},
  loading = "lazy",
  objectFit = "contain",
  objectPosition = "50% 50%",
  backgroundColor = "transparent",
  placeholder,
  formats,
  quality,
  breakpoints,
  transformOptions,
  as: Component = "div",
  ...rest
}) => {

  const wrapperStyle: React.CSSProperties = {
    display: "inline-block",
    overflow: "hidden",
    position: "relative",
    ...style,
  };

  const imageStyle: React.CSSProperties = {
    width: width ? isNaN(width) ? width : `${width}px` : "auto",
    height: height ? isNaN(height) ? height : `${height}px` : "auto",
    objectFit,
    objectPosition,
    ...imgStyle,
  };

  if (width) wrapperStyle.width = width;
  if (height) wrapperStyle.height = height;
  if (backgroundColor) wrapperStyle.backgroundColor = backgroundColor;

  return (
    <Component className={className} style={wrapperStyle} {...rest}>
      <img
        src={src}
        alt={alt}
        loading={loading}
        className={imgClassName}
        style={imageStyle}
        width={width}
        height={height}
      />
    </Component>
  );
};

export default StaticImage; 